export default __webpack_public_path__ + "img/b602a739d4632381ff53a7235d00d8ca.svg";